import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import config from '../config';
import moment from 'moment';
import { createAuth } from '../Helpers';

export const reducerName = 'winterDutyState';

export const getAllWinterDuties = createAsyncThunk(
    'winterDutyState/getAllWinterDuties',
    async (_, { getState, rejectWithValue }) => {
        try {
            const state = getState().calendarState;
            const startTime = moment(state.start).format('YYYY-MM-DD');
            const endTime = moment(state.start)
                .add(state.numberOfDays - 1, 'days')
                .format('YYYY-MM-DD');

            const response = await axios({
                method: 'POST',
                url: `${config.server}/api/winterduties/search`,
                withCredentials: true,
                auth: createAuth(getState),
                data: { startTime, endTime },
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'An error occurred');
        }
    }
);

export const getAllVintermanToday = createAsyncThunk(
    'winterDutyState/getAllVintermanToday',
    async (_, { getState, rejectWithValue }) => {
        try {
            const response = await axios({
                method: 'GET',
                url: `${config.server}/api/vinterman/getAll`,
                withCredentials: true,
                auth: createAuth(getState),
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'An error occurred');
        }
    }
);

export const getAllRoutes = createAsyncThunk(
    'winterDutyState/getAllRoutes',
    async (_, { getState, rejectWithValue }) => {
        try {
            const response = await axios({
                method: 'GET',
                url: `${config.server}/api/winterduties/routes`,
                withCredentials: true,
                auth: createAuth(getState),
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'An error occurred');
        }
    }
);

const initialState = {
    error: null,
    status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
    winterDuties: [],
    routes: [],
};

const winterDutySlice = createSlice({
    name: reducerName,
    initialState,
    reducers: {
        setInterval: (state, action) => {
            state.startTime = action.payload.start;
            state.endTime = action.payload.end;
        },
    },
    extraReducers: (builder) => {
        // getAllWinterDuties
        builder
            .addCase(getAllWinterDuties.pending, (state) => {
                state.status = 'loading';
                state.error = null; 
            })
            .addCase(getAllWinterDuties.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.winterDuties = action.payload; 
            })
            .addCase(getAllWinterDuties.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload || 'An error occurred';
            });

        // getAllVintermanToday
        builder
            .addCase(getAllVintermanToday.pending, (state) => {
                state.status = 'loading';
                state.error = null; 
            })
            .addCase(getAllVintermanToday.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.winterDuties = action.payload; 
            })
            .addCase(getAllVintermanToday.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload || 'An error occurred'; 
            });

        // getAllRoutes
        builder
            .addCase(getAllRoutes.pending, (state) => {
                state.status = 'loading';
                state.error = null; 
            })
            .addCase(getAllRoutes.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.routes = action.payload; 
            })
            .addCase(getAllRoutes.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload || 'An error occurred'; 
            });
    },
});

export const { setInterval } = winterDutySlice.actions;
export default winterDutySlice.reducer;